export default {"src":"/_next/static/media/table-dead-state-icon.cf9bbac3.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};